import { defaultIconProps, IconProps } from './IconProps';

export const IconCheck: React.FC<IconProps> = ({ size, color, strokeWidth, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M16.6663 5L7.49967 14.1667L3.33301 10" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

IconCheck.defaultProps = defaultIconProps;
